import Switch from './Switch';

// The label + description + switch row used by the restaurant-settings form.
//
// Lifted out of SettingsPage so the Command Center's inline editor renders the
// SAME control rather than a look-alike copy — the two screens edit one row and
// should not drift into two visual languages for the same setting. The switch
// itself is components/Switch.jsx, shared with the classification rules.
export default function SettingsToggle({ checked, onChange, label, description }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
      <div>
        <div style={{ fontWeight: 600, fontSize: '0.95rem', color: 'var(--ink)' }}>{label}</div>
        {description && <div style={{ fontSize: '0.82rem', color: 'var(--ink-muted)', marginTop: 3 }}>{description}</div>}
      </div>
      <Switch checked={checked} onChange={onChange} label={label} />
    </div>
  );
}
